<div class="ticker-tape-container">
    <marquee class="ticker-tape-content" behavior="scroll" direction="left">
        <span *ngFor="let item of items; let i = index" class="ticker-item">
            {{ item }}
            <ng-container *ngIf="i < items.length - 1"> | </ng-container>
        </span>
    </marquee>
</div>